export const VARIABLE_LABEL = "Variable";

export const VARIABLE_INFO_TOOLTIP =
    "Integration placeholder; Kick creates GL accounts for each financial " +
    "account you connect.";
